// extracted by mini-css-extract-plugin
module.exports = {"indicatorBox":"indicator-box_indicatorBox__DR4jK","dBlock":"indicator-box_dBlock__3piMg"};